import React, { useState } from 'react';

import { Box, MenuItem } from '@mui/material';

import { FilterMenuButton, StyledAngle, StyledMenu } from './styles';

const FilterMenu = ({ onChange, value, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleFilterSelect = (key) => {
    onChange(key);
    handleClose();
  };

  return (
    <Box>
      <FilterMenuButton
        onClick={handleClick}>
        <span>{options.find(({ key }) => key === value)?.value}</span>
        <StyledAngle
          isMenuOpen={open}
        />
      </FilterMenuButton>
      <StyledMenu
        id='user-profile-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby' : 'basic-button',
        }}>
        {options.map(({ key, value }) => (
          <MenuItem
            key={key} onClick={() => handleFilterSelect(key)}>
            {value}
          </MenuItem>
        ))}
      </StyledMenu>
    </Box>
  );
};

export default FilterMenu;
